import { FC, useCallback, useContext, useState } from 'react';

import { Button } from '@smartshell/ui-kit';
import { createPortal } from 'react-dom';

import { LocalizationContext } from 'localization';

import {
  ShellOverlay,
  SHELL_CLOSED_SPLIT_POSITION,
  SHELL_OPEN_SPLIT_POSITION,
} from './ShellOverlay';
import s from './ShellToggleButton.module.scss';

const clampSplitPosition = (position: number): number =>
  Math.max(0, Math.min(SHELL_CLOSED_SPLIT_POSITION, position));

export const ShellToggleButton: FC = () => {
  const { t } = useContext(LocalizationContext);
  const [isOpen, setIsOpen] = useState(false);
  const [splitPosition, setSplitPositionState] = useState(
    SHELL_OPEN_SPLIT_POSITION
  );

  const setSplitPosition = useCallback((position: number): void => {
    if (!Number.isFinite(position)) return;

    const nextPosition = clampSplitPosition(position);

    setSplitPositionState(nextPosition);
    setIsOpen(nextPosition !== SHELL_CLOSED_SPLIT_POSITION);
  }, []);

  const toggle = (): void => {
    if (isOpen) {
      setIsOpen(false);
      return;
    }

    setSplitPositionState(SHELL_OPEN_SPLIT_POSITION);
    setIsOpen(true);
  };

  return (
    <>
      <Button
        className={s.ssShellToggleButton}
        color="blue"
        iconName="ComputerIcon"
        size="s"
        variant="outline"
        onClick={toggle}
      >
        {t(isOpen ? 'shell.hide' : 'shell.open')}
      </Button>
      {createPortal(
        <ShellOverlay
          isOpen={isOpen}
          splitPosition={splitPosition}
          setSplitPosition={setSplitPosition}
        />,
        document.body
      )}
    </>
  );
};
